<template>
  <div>
    <div class="content_header">
      <v-toolbar flat color="white mx-2">
        <v-toolbar-title>広告管理コード管理</v-toolbar-title>
        <v-divider class="mx-2 mr-4 pr-4" inset vertical></v-divider>

        <link rel="stylesheet" href="styles.css" />
        <link rel="stylesheet" href="common_new.css" />
        <link rel="stylesheet" href="common.css" />
        <link rel="stylesheet" href="smartphone.css" />

        <v-row>
          <!-- <v-col cols="auto" style="min-width: 160px">
            <v-card-subtitle style="font-size:18px; padding-top:18px;"
              >カテゴリ</v-card-subtitle
            >
          </v-col> -->
          <v-col cols="4" class="pt-4">
            <v-text-field v-model="target_category" disabled></v-text-field>

            <!-- <v-autocomplete
              :loading="loading"
              :items="categorySelect"
              item-text="name"
              item-value="id"
              v-model="target_category"
              clearable
              label=""
              return-object
              hide-details
            ></v-autocomplete
          > -->
          </v-col>

          <!-- <v-col cols="2" class="pt-4"
            ><v-row justify="center">
              <v-dialog v-model="dialog" persistent max-width="600px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" outlined dark v-bind="attrs" v-on="on">
                    + 新規カテゴリ登録
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">新規カテゴリ追加</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="カテゴリ名"
                            v-model="new_category"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">
                      キャンセル
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="addCategory()">
                      OK
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog></v-row
            ></v-col
          > -->
          <v-col>
            <v-card-subtitle
              style="font-size:18px; padding-top:18px; color:red;"
              >{{ target_env }}接続中</v-card-subtitle
            >
          </v-col>
        </v-row>
      </v-toolbar>
    </div>

    <div class="pa-2">
      <v-card class="pl-4 ma-0 mb-4" :disabled="loading">
        <v-row
          align="center"
          v-if="target_category != null && target_category != ''"
        >
          <v-col cols="10">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              clearable
              class="pl-8"
              style="max-width:600px;margin-left:10px;"
            ></v-text-field>
          </v-col>
          <v-col cols="2" style="max-width:120px;text-align:right;">
            <v-btn color="blue" dark @click="createLinkCode()"
              >+ 新規作成</v-btn
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="auto" style="min-width: 160px; text-align: center">
            <v-card-subtitle class="pa-2"
              >ショートコード</v-card-subtitle
            ></v-col
          >
          <v-col cols="9"
            ><div class="pt-2 pb-2" v-html="messageShortCode(shortcode)"></div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span style="color: red">{{ error_name }}</span>

            <v-data-table
              :headers="headers"
              :items="nameList"
              :search="search"
              :items-per-page="50"
              @click:row="dispShortCode2"
            >
              <template v-slot:item.edit="{ item }">
                <v-btn outlined class="transparent" @click="loadLinkCode(item)">
                  <v-icon small color="primary">fas fa-edit</v-icon>
                </v-btn>
              </template>

              <template v-slot:item.code="{ item }">
                <v-btn outlined class="transparent" @click="copyItem(item)">
                  <v-icon small color="primary">fas fa-clipboard</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="amber"
        ></v-progress-linear>
      </v-card>

      <!-- <div class="ml-4">
        <v-checkbox v-model="csvMode" label="CSV読み込み"></v-checkbox>
      </div> -->

      <v-row justify="center">
        <v-dialog v-model="showDialog" scrollable persistent max-width="1500px">
          <v-card width="800" :disabled="loading">
            <v-overlay :absolute="true" :value="loading">
              <v-progress-circular
                :size="70"
                :width="7"
                color="yellow"
                indeterminate
              ></v-progress-circular>
            </v-overlay>

            <v-card-title class="pa-0" style="height:160px">
              <v-row class="pa-4 ml-1" style="width:100%">
                <v-col col="auto" style="max-width:140px"
                  >{{ target_category }}
                </v-col>
                <v-col col="4"
                  ><v-text-field
                    hide-details="auto"
                    class="pa-0"
                    :rules="rules"
                    ref="new_name"
                    autofocus
                    v-model="target_name"
                  ></v-text-field>
                </v-col>
                <v-col col="4" class="text-right"
                  ><v-btn
                    color="blue darken-1"
                    text
                    @click="checkSaveAction()"
                    style="font-size:40px;"
                    >×</v-btn
                  ></v-col
                ></v-row
              >

              <v-row class="pl-3 pr-3">
                <v-col cols="auto" class="pa-0 pl-3">
                  <v-tabs v-model="items_tab" class="tablist">
                    <v-tab
                      v-for="(item, index) in items"
                      :key="index"
                      class="ma-2 pa-4"
                      style="margin-right:1px;"
                      >{{ displayName(index) }}

                      <v-btn
                        @click="deleteItem(index)"
                        outlined
                        class="deletebtn pa-0"
                        v-show="index > 0"
                      >
                        <v-icon smll color="red darken-2">
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </v-tab>
                  </v-tabs></v-col
                >
                <v-col class="pa-0 pr-4" v-if="items.length > 0">
                  <v-btn
                    class="float-left addSetting"
                    @click="addItem()"
                    outlined
                    >+ 時限式追加</v-btn
                  >

                  <v-btn class="float-right" @click="save()" color="primary"
                    >保存({{ target_env }}反映)</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-title>

            <v-divider></v-divider>

            <v-row align="center" class="ml4">
              <v-col cols="auto"><div>プレビュー形式</div></v-col>
              <v-col cols="auto">
                <v-radio-group v-model="target_mode" class="ml-8" row>
                  <v-radio label="html" value="html"></v-radio>
                  <v-radio label="csv" value="csv"></v-radio> </v-radio-group
              ></v-col>
            </v-row>

            <v-card-text
              style="width:100%;height: 1200px; background:#efefef;padding:10px;"
            >
              <v-tabs-items v-model="items_tab">
                <v-tab-item
                  v-for="(item, index) in items"
                  :key="index"
                  class="mt-0 mb-2"
                  style="border-bottom: 1px solid #ddd ;"
                >
                  <div v-if="item.additem">
                    <table class="pa-1" style="width: 100%">
                      <tr>
                        <th width="120">開始時刻</th>
                        <td class="pa-1" width="40%">
                          <VueCtkDateTimePicker
                            v-model="item.start_date"
                            :minute-interval="1"
                            :format="'YYYY-MM-DD HH:mm'"
                            :overlay="true"
                            label="start"
                            :no-label="true"
                          ></VueCtkDateTimePicker>
                        </td>
                        <th width="120">終了時刻</th>
                        <td class="pa-1" width="40%">
                          <VueCtkDateTimePicker
                            v-model="item.end_date"
                            :minute-interval="1"
                            :format="'YYYY-MM-DD HH:mm'"
                            :overlay="true"
                            label="end"
                            :no-label="true"
                          ></VueCtkDateTimePicker>
                        </td>

                        <td width="180" style="color: green">
                          {{ timeSub(item.start_date, item.end_date) }}
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div v-else>
                    <p class="pa-0 pl-5 pt-4">
                      時限式表示設定がない(または設定時間外)場合は、デフォルトで設定した内容が表示されます。
                    </p>
                  </div>

                  <div class="pl-4" v-if="target_mode == 'csv'">
                    <!-- CSV読み込みボタン -->
                    <label>
                      <input
                        v-if="inputview"
                        type="file"
                        @change="loadCsvFile(index, $event)"
                      /><span
                        style="color:red;font-size:12px;padding-left:10px;"
                        >（CSVファイル読み込み）</span
                      >
                    </label>

                    <p>{{ message }}</p>

                    <div v-html="checkCsv"></div>

                    <!-- {{checkCsv}} -->
                    <!-- <div v-html="checkCsv(index)"></div> -->

                    <!-- <table class="preview_csv">
                      <tr v-for="(csvitem, index) in csvData" :key="index">
                        <td v-for="(column, index) in csvitem" :key="index">
                          {{ column }}
                        </td>
                      </tr>
                    </table> -->
                  </div>

                  <v-row
                    style="width: 100%"
                    class="pb-2"
                    v-if="target_mode == 'html'"
                  >
                    <v-col cols="7" class="">
                      <v-card-text>
                        <v-textarea
                          outlined
                          label="HTML"
                          v-model="item.text"
                          rows="16"
                          hide-details="true"
                        ></v-textarea> </v-card-text
                    ></v-col>
                    <v-col cols="5">
                      <!-- プレビューエリア -->
                      <div
                        class="preview post-content"
                        style="background: #f0f0f0; padding: 10px"
                      >
                        <div v-html="convertMarkdownToHtml(item)"></div>
                      </div>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="checkSaveAction()"
                >閉じる</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </div>
</template>
<script>
// Ajax通信ライブラリ
import axios from "axios";

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  components: {
    VueCtkDateTimePicker: VueCtkDateTimePicker,
  },

  data() {
    return {
      search: "",
      headers: [
        {
          text: "編集",
          align: "center",
          value: "edit",
          sortable: false,
          width: "70px",
        },
        {
          text: "id",
          value: "id",
          align: "center",
          width: "100px",
        },
        { text: "name", value: "name" },
        { text: "mode", value: "mode" },

        { text: "作成日", value: "create_date" },
        { text: "更新日", value: "update_date" },
        { text: "ショートコード", value: "code", width: "200px" },
      ],

      target_env: "", //DBの向き先

      rules: [(value) => !!value || "入力必須"],

      new_create_flg: false,

      showDialog: false,
      // tab: 1,
      items_tab: 0,
      categorySelect: [],

      nameList: [],

      items: [],
      alldatas: [],
      before_datas: "[]", //修正前のデータ

      target_name: "",
      target_category: "",
      target_mode: "",

      dialog: false,
      loading: false,
      shortcode: "",

      new_category: "",
      new_linkcodename: "",
      text: "",
      name: "",

      inputview: true,

      error_name: "",
      csvMode: false,
      message: "",
      csvData: [],
      saveFlg: false,
    };
  },

  beforeCreate: function() {
    this.loading = true;
    axios
      .get(process.env.VUE_APP_LINKCODE_LIST_CATEGORY, {
        params: {},
      })
      .then((response) => {
        // this.items = response.data;
        this.categorySelect = response.data;
        // console.log(response)
      })
      .finally(() => {
        this.loading = false;
      });
  },

  computed: {
    checkCsv: function() {
      if (this.items[this.items_tab] == null) {
        return "";
      }

      let linesArr = [];
      let output = "";
      let lines = this.items[this.items_tab].text.split("\n");
      if (lines.length == 1) {
        return "";
      }

      for (let i = 0; i < lines.length; i++) {
        linesArr[i] = lines[i].split(",");
        output += "<tr>";
        for (let t = 0; t < linesArr[i].length; t++) {
          output += "<td>" + linesArr[i][t] + "</td>";
        }
        output += "</tr>";
      }
      return "<table class='preview_csv'>" + output + "</table>";
    },
  },

  watch: {
    target_category: function(val) {
      this.target_name = "";
      this.reset();

      if (val != null) {
        this.getLinkCodeListByCategory();
      } else {
        this.nameList = [];
      }
      // console.log(val + " changed " + oldVal);
    },
    tab: function() {
      this.reset();
      // console.log(val + " changed " + oldVal);
    },

    target_name: function(val) {
      if (this.nameList.includes(val) && this.new_create_flg) {
        this.error_name = "名称が重複しています";
        // console.log(val + " changed " + oldVal);
      } else {
        this.error_name = "";
      }
    },
  },

  created: function() {
    // this.initItem();
    this.mainDisplay = true;
    this.target_env = process.env.VUE_APP_LINKCODE_LIST_CATEGORY;
    if (this.target_env.indexOf("tool-test") > -1) {
      this.target_env = "テストDB";
    } else {
      this.target_env = "本番DB";
    }

    this.target_category = "広告管理";
  },

  methods: {
    reset: function() {
      this.saveFlg = false;
      this.target_name = "";
      this.items = [];
      this.before_datas = "[]";
      this.shortcode = "";
      this.new_create_flg = false;
      this.csvData = [];
      this.inputview = false;
      this.$nextTick(function() {
        this.inputview = true;
      });
    },

    //時間差分
    timeSub: function(start, end) {
      if (start == "" || end == "") {
        return "";
      }

      var date1 = new Date(start);
      var date2 = new Date(end);
      var diff = date2 - date1;
      console.log("diff", diff);
      var day = Math.abs(diff) / (24 * 60 * 60 * 1000);
      var hour =
        (diff - Math.floor(day) * (24 * 60 * 60 * 1000)) / (60 * 60 * 1000);

      // ミリ秒 （そのまま）
      console.log("day", Math.floor(day));
      console.log("hour", Math.floor(hour));

      return "約" + Math.floor(day) + "日" + Math.floor(hour) + "時間";
    },

    //初期アイテム
    initItem: function() {
      var tmp = {
        additem: false,
        start_date: "",
        end_date: "",
        text: "",
        mode: "html", // false : html形式,  true : csv形式
      };
      this.items.push(tmp);
    },

    //追加アイテム（時限設定付き）
    addItem() {
      if (this.items.length > 2) {
        alert("時限式は最大2つまでしか設定できません");
        return;
      }

      var item = {
        additem: true,
        start_date: "",
        end_date: "",
        text: "",
      };
      this.items.push(item);

      //タブ切替
      this.items_tab = this.items.length - 1;
    },

    convertMarkdownToHtml: function(item) {
      const replaced = item.text.replace(
        /"\/wp-content/g,
        "https://appmedia.jp/wp-content"
      );

      return replaced;
    },

    //リンクコードの新規作成
    createLinkCode() {
      this.reset();
      this.new_create_flg = true;
      this.initItem();
      this.target_id = -1;

      this.showDialog = true;
    },

    copyItem(item) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(this.dispShortCode2(item))
          .then(() => {
            alert(
              "ショートコードをコピーしました。そのまま記事に貼り付けてください"
            );
          })
          .catch((e) => {
            console.error(e);
          });
      } else {
        console.log("ローカル環境はコピーは使えません！");
      }
    },

    //CSVファイルのの読み込み
    loadCsvFile(index, e) {
      console.log(index);

      this.csvData = [];
      this.message = "";
      let file = e.target.files[0];

      // console.log(file)

      if (file.name.indexOf(".csv") <= -1 && file.name.indexOf(".txt") <= -1) {
        this.message = "CSVやテキストファイルを選択してください";
        return;
      }

      // if (!file.type.match("text/csv") && !file.type.match("text/plain")) {
      //   this.message = "CSVやテキストファイルを選択してください";
      //   return;
      // }

      let reader = new FileReader();
      reader.readAsText(file);

      reader.onload = () => {
        let lines = reader.result.split("\n");
        lines.shift();
        let linesArr = [];
        for (let i = 0; i < lines.length; i++) {
          linesArr[i] = lines[i].split(",");
        }
        this.csvData = linesArr;

        this.items[index].text = reader.result;
      };
    },

    loadLinkCode(item) {
      this.reset();
      this.target_id = item.id;
      this.target_name = item.name;

      this.target_mode = item.mode;
      this.new_create_flg = false;
      this.items = [];
      if (this.alldatas[item.name] == null) {
        var tmp = {
          additem: false,
          start_date: "",
          end_date: "",
          text: "",
        };
        this.items.push(tmp);
      }

      if (this.alldatas[item.name].length <= 0) {
        return;
      }

      // this.alldatas[item].forEach((val) => {
      var content = this.alldatas[item.name][0].text;

      // this.dispShortCode(this.alldatas[item.name][0].id, item.name);

      var saveData = JSON.parse(content);

      saveData.default.forEach((val2) => {
        var tmp = {
          additem: false,
          start_date: "",
          end_date: "",
          text: val2.text,
        };
        this.items.push(tmp);
      });

      saveData.timer.forEach((val2) => {
        var tmp = {
          additem: true,
          start_date: val2.start,
          end_date: val2.end,
          text: val2.text,
        };
        this.items.push(tmp);
      });

      this.before_datas = JSON.stringify(this.items);
      // this.displayCsvData();
      this.showDialog = true;
    },

    addCategory() {
      this.categorySelect.push(this.new_category);
      this.target_category = this.new_category;
      this.dialog = false;
    },

    deleteItem(index) {
      if (window.confirm("選択したアイテムを削除します")) {
        this.items.splice(index, 1);
      }
    },

    getLinkCodeListByCategory() {
      var self = this;
      if (this.target_category == "") {
        return;
      }

      var tmp_name = this.target_name;

      this.loading = true;

      this.nameList = [];

      axios
        .get(process.env.VUE_APP_LINKCODE_LIST_NAME, {
          params: { category: self.target_category },
        })
        .then((response) => {
          // this.nameList = response.data.namelist;
          this.alldatas = response.data.data;

          //  console.log(this.alldatas)
          Object.keys(this.alldatas).forEach((key) => {
            this.nameList.push(this.alldatas[key][0]);
          });
          if (this.tab == 1) {
            this.target_name = tmp_name;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 未保存チェック
    checkSaveAction() {
      var check1 = this.before_datas;
      var check2 = JSON.stringify(this.items);
      if (check1 != "[]" && check1 != check2) {
        if (
          !window.confirm(
            "変更が保存されていません。移動すると変更内容が失われます。"
          )
        ) {
          return true;
        }
      }

      this.showDialog = false;
    },

    save() {
      var save_text = {};
      save_text["default"] = [];
      save_text["timer"] = [];

      //エラーチェック
      var error_flg = false;

      if (this.target_category == "" || this.target_category == null) {
        alert("カテゴリを選択してください");
        return;
      }

      var check_name = this.target_name;
      check_name = check_name.trim();
      if (check_name == "" || check_name == null || this.error_name != "") {
        alert("名称を入力してください");
        return;
      }

      var check = false;
      Object.keys(this.nameList).forEach((key) => {
        if (
          this.nameList[key]["id"] != this.target_id &&
          this.nameList[key]["name"].trim() == this.target_name.trim()
        ) {
          check = true;
        }
      });
      if (check) {
        alert("名称が重複しています");
        return;
      }

      this.items.forEach((val) => {
        if (val.additem) {
          if (val.start_date == "" || val.start_date == "") {
            alert("日付を設定してください");
            error_flg = true;
            return;
          }

          if (
            val.start_date != "" &&
            val.start_date != "" &&
            val.start_date >= val.end_date
          ) {
            alert(
              "日付の設定が間違っています。終了日は開始日より後の日付を設定してください"
            );
            error_flg = true;
            return;
          }
        }

        var tmp = {
          start: val.start_date,
          end: val.end_date,
          text: val.text,
        };
        if (val.additem) {
          save_text["timer"].push(tmp);
        } else {
          save_text["default"].push(tmp);
        }
      });
      if (error_flg) {
        return;
      }

      if (!window.confirm("データを保存します(" + this.target_env + "反映)")) {
        return;
      }

      this.loading = true;

      var text = JSON.stringify(save_text);
      var item = {
        id: this.target_id,
        category: this.target_category,
        name: this.target_name,
        mode: this.target_mode,
        text: text,
      };
      axios
        .post(process.env.VUE_APP_LINKCODE_UPDATE, {
          data: item,
        })
        .then(() => {
          // this.dispShortCode(response.data.last_id, this.target_name);
          // if (this.tab == 0) {
          this.getLinkCodeListByCategory();
          alert("保存しました！");

          this.before_datas = JSON.stringify(this.items);
          this.showDialog = false;
          // }
        })
        .catch((error) => {
          alert("名称が空か空白が設定されています\n" + error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    dispShortCode2(data) {
      this.shortcode =
        '[common_new_linkcode category="' +
        this.target_category +
        '" name="' +
        data.name +
        '" filename=' +
        data.id +
        "]";
    },

    // dispShortCode(id, name) {
    //   this.shortcode =
    //     '[common_new_linkcode category="' +
    //     this.target_category +
    //     '" name="' +
    //     name +
    //     '" filename=' +
    //     id +
    //     "]";
    // },

    messageShortCode(i) {
      if (i == "" && this.tab == 0) {
        return "<span style='color:green;font-size:90%'>新規登録時は、保存後に表示されます</span>";
      }
      return i;
    },

    displayName(i) {
      if (i == 0) {
        return "デフォルト";
      } else {
        return "時限式設定(" + i + ")";
      }
    },
  },

  // //  //描写前の処理（一覧表示）
  // async asyncData({ app }) {
  //   var response = [];
  //   const baseUrl =
  //     "https://article.matomeroyal.com/wp-json/appmedia/tool/review_category_list";
  //   response = await app.$axios.$get(baseUrl);
  //   return {
  //     category: response
  //   };
  // }
};
</script>
<style>
.v-card__title {
  padding: 6px 18px !important;
}
.col {
  padding: 4px 18px !important;
}
.v-card__text {
  padding: 0 0 0 10px;
}

.v-input--radio-group__input {
  flex-wrap: wrap;
}

/* .preview{
  border: 1px solid red !important;
} */

/* .preview img {
  width: auto;
  max-height: 400px;
} */

.namelist .v-input--radio-group__input {
  flex-direction: row !important;
}
.namelist .v-radio {
  padding: 6px 16px 6px 0;
  margin: 4px 10px 4px 0 !important;
  border-right: 1px solid #ddd;
}

.namelist .v-item--active label {
  color: #1976d2;
}

.tablist .v-tab--active {
  color: #1976d2;
  font-weight: bold;
}

.v-text-field input {
  font-size: 16px;
}
.v-textarea textarea {
  line-height: 1.6;
  font-size: 15px;
}

.new_icon {
  border: 1px solid red;
  color: red;
  margin-right: 8px;
  padding: 1px 4px;
}

.v-application .addSetting {
  padding: 0 16px;
  margin: 9px;
  height: 32px !important;
  border: none;
  background: #fff;
  color: #6d6d6d;
  font-weight: bold;
  font-size: 14px;
  border: 1px dashed #aaa;
}
main .v-application .addSetting::before {
  content: "＋";
  font-size: 30px;
}

.deletebtn {
  color: red !important;
  font-weight: bold;
  margin-left: 10px;
  border: none;
  min-width: 40px !important;
}

.preview_csv {
  border-collapse: collapse;
}

.preview_csv td {
  font-size: 12px;
  line-height: 1.4;
  color: #333;
  border: 1px solid #ccc;
  padding: 4px;
  text-align: center;
}

.preview_csv tr:nth-child(odd) td {
  background: #fff3ef;
}
</style>
